<template>
    <el-card class="box-card" body-style="padding:0" shadow="hover">
        <div slot="header" class="clearfix">
            <span>同时患有多种疾病的人数 {{ total }}</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="getTableData">刷新</el-button>
        </div>
        <el-table :data="table.tableData" strip style="width: 100%;" height="300px" v-loading="table.loading">
            <el-table-column type="index" width="50" align="center">
                <template slot-scope="scope">
                    <div v-text="scope.$index + 1 + ((table.page - 1) * table.pageSize)"></div>
                </template>
            </el-table-column>
            <el-table-column label="患疾数" width="380">
                <template slot-scope="scope">
                    同时患有 <span style="color:red">{{scope.row.c1}}</span> 种疾病的人数
                </template>
            </el-table-column>
            <el-table-column prop="count" label="数量" width="" />
        </el-table>
    </el-card>
</template>

<script>
export default {
    name: 'analysis-manbing-table-renshu',
    data() {
        return {
            total: 0,
            table: {
                loading: false,
                page: 1,
                pageSize: 20,
                total: 0,
                tableData: []
            }
        }
    },
    methods: {
        handleCurrentChange(e) {
            this.table.page = e
            this.getTableData()
        },
        handleSizeChange(e) {
            this.table.pageSize = e
            this.table.page = 1
            this.getTableData()
        },
        async getTableData() {
            this.table.loading = true
            const resp = await this.$http.get(`/manbing/renshu`)
            this.table.tableData = resp.data.data
            this.total = this.table.tableData.reduce((acc, obj) => acc + obj.count, 0);
            this.table.loading = false
        }
    },
    mounted() {
        this.getTableData()
    }
}
</script>